export default "__VITE_ASSET__BzTru0uB__"